<template>
    <button 
        type="button"
        class="google-login-btn"
        :class="{ 'google-login-btn--icon': type === 'icon' }"
        @click="redirectToGoogle"
    >
        <img src="@/assets/images/google-logo.svg" alt="Google" />
        <span v-if="type !== 'icon'" class="google-login-btn__text">
            {{ buttonText }}
        </span>
    </button>
</template>

<script>
export default {
    name: 'GoogleLoginButtonRedirection',
    props: {
        text: {
            type: String,
            default: 'continue_with',
            validator: (value) => ['continue_with', 'signin_with', 'signup_with'].includes(value)
        },
        type: {
            type: String,
            default: 'standard'
        }
    },
    computed: {
        buttonText() {
            const texts = {
                'continue_with': this.$t('Continue with Google'),
                'signin_with': this.$t('Sign in with Google'),
                'signup_with': this.$t('Sign up with Google')
            };
            return texts[this.text] || texts['continue_with'];
        }
    },
    methods: {
        generateState() {
            const state_data = {
                ...this.$route.query,
                nonce: this.makeID(16),
            };
            const state_string = btoa(JSON.stringify(state_data));
            sessionStorage.setItem('google_oauth_state', state_string);
            return state_string;
        },
        buildGoogleOAuthUrl() {
            const client_id = globalThis.ENV?.VUE_APP_GOOGLE_CLIENT_ID;
            if (!client_id) {
                throw new Error(this.$t('Google Sign In is not configured'));
            }
            const redirect_uri = `${globalThis.location.origin}/oauth/google/callback`;
            const params = new URLSearchParams({
                client_id,
                redirect_uri,
                response_type: 'code',
                scope: 'email profile openid',
                state: this.generateState(),
                access_type: 'offline',
                prompt: 'select_account'
            });
            return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
        },
        redirectToGoogle() {
            try {
                // Always navigate this frame — parent-frame navigation is blocked in embedded WKWebViews.
                globalThis.location.assign(this.buildGoogleOAuthUrl());
            } catch (err) {
                const message = err?.message || this.$t('An error occurred during sign in');
                this.$toasted.global.errorMessage(message);
            }
        }
    }
};
</script>

<style lang="scss">
.google-login-btn {
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #d6d9dc;
    border-radius: 4px;
    color: #3b4045;
    cursor: pointer;
    display: flex;
    height: 40px;
    justify-content: center;
    line-height: 110%;
    max-width: 100%;
    padding: 0 12px;
    transition: 0.1s all;
    width: 220px;
    flex-wrap: nowrap;

    &:hover {
        background-color: #f8f9f9;
    }

    &--icon {
        width: 40px;
        padding: 0;
    }

    &__text {
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 0.25px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: auto;
    }

    img {
        height: 16px;
        margin-right: 5px;
        width: 16px;
    }

    &--icon img {
        margin-right: 0;
    }
}
</style>
